// Curated Bible verses & short prayers shown when a roadblock is encountered.
export const VERSES = [
  {
    type: "verse",
    reference: "Psalm 23:4",
    text: "Even though I walk through the darkest valley, I will fear no evil, for you are with me; your rod and your staff, they comfort me.",
  },
  {
    type: "verse",
    reference: "Proverbs 3:5-6",
    text: "Trust in the Lord with all your heart and lean not on your own understanding; in all your ways submit to him, and he will make your paths straight.",
  },
  {
    type: "verse",
    reference: "Isaiah 41:10",
    text: "So do not fear, for I am with you; do not be dismayed, for I am your God. I will strengthen you and help you; I will uphold you with my righteous right hand.",
  },
  {
    type: "verse",
    reference: "Philippians 4:13",
    text: "I can do all this through him who gives me strength.",
  },
  {
    type: "verse",
    reference: "Romans 8:28",
    text: "And we know that in all things God works for the good of those who love him, who have been called according to his purpose.",
  },
  {
    type: "verse",
    reference: "John 14:6",
    text: "Jesus answered, 'I am the way and the truth and the life. No one comes to the Father except through me.'",
  },
  {
    type: "verse",
    reference: "Matthew 11:28",
    text: "Come to me, all you who are weary and burdened, and I will give you rest.",
  },
  {
    type: "verse",
    reference: "Joshua 1:9",
    text: "Be strong and courageous. Do not be afraid; do not be discouraged, for the Lord your God will be with you wherever you go.",
  },
  {
    type: "verse",
    reference: "Psalm 46:1",
    text: "God is our refuge and strength, an ever-present help in trouble.",
  },
  {
    type: "verse",
    reference: "2 Corinthians 12:9",
    text: "My grace is sufficient for you, for my power is made perfect in weakness.",
  },
  {
    type: "verse",
    reference: "Jeremiah 29:11",
    text: "For I know the plans I have for you, declares the Lord, plans to prosper you and not to harm you, plans to give you hope and a future.",
  },
  {
    type: "verse",
    reference: "Romans 10:9",
    text: "If you declare with your mouth, 'Jesus is Lord,' and believe in your heart that God raised him from the dead, you will be saved.",
  },
  {
    type: "prayer",
    reference: "A Prayer for Strength",
    text: "Lord, when the road grows heavy, remind me that you walk beside me. Steady my hands, quiet my heart, and guide me one mile at a time toward you.",
  },
  {
    type: "prayer",
    reference: "A Prayer for Peace",
    text: "Father, in the middle of this storm, breathe peace into my soul. Where fear rises, let your presence be greater. Where I stumble, hold me firm.",
  },
  {
    type: "prayer",
    reference: "A Prayer for the Journey",
    text: "Jesus, be my compass. When the way is unclear, light the path. When I want to turn back, remind me of the destination. Bring me home.",
  },
  {
    type: "prayer",
    reference: "A Prayer of Surrender",
    text: "I give you my worries, my burdens, my broken pieces. Take them, Lord, and trade them for your peace. I trust you with what I cannot carry.",
  },
];

export function randomVerse(exclude = null) {
  if (VERSES.length === 1) return VERSES[0];
  let v = VERSES[Math.floor(Math.random() * VERSES.length)];
  let guard = 0;
  while (exclude && v.reference === exclude && guard < 8) {
    v = VERSES[Math.floor(Math.random() * VERSES.length)];
    guard += 1;
  }
  return v;
}
